export default __webpack_public_path__ + "static/media/navi.e26f3c0c.svg";